module.exports = __webpack_public_path__ + "img/banner-tc1-m.5d110e55.jpg";